import styled, { css } from 'styled-components';
import { ContentContainer } from '../Card';

import { modeProperty } from '../Theme/modeProperty';
import { ICalculateStatsStatus } from './Table';
export type TableRowPropsType = {
  highlightRow?: 'odd' | 'even';
  isHover?: boolean;
  statsStatus?: ICalculateStatsStatus;
};

type TableCellPropsType = {
  align?: 'left' | 'right';
  noWrap?: boolean;
  width?: string;
};
type SimpleContainerProps = {
  hasBorder: boolean;
  roundedTop: boolean;
  roundedBottom: boolean;
};

export const hoverTableItemMixin = css`
  &:hover {
    background: linear-gradient(90deg, rgba(255, 192, 0, 0.5) 0%, rgba(255, 192, 0, 0) 100%);
    cursor: pointer;
  }
`;
export const StyledContentContainer = styled(ContentContainer)`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const TableHalfCell = styled.td`
  width: 50%;
`;

export const TableCellLabel = styled.div`
  display: none;

  ${({ theme }) => theme.breakpoints.down('md')} {
    display: block;
    font-family: ${({ theme }) => theme.baseFont};
    text-transform: uppercase;
    font-size: 0.6rem;
    font-weight: 600;
    letter-spacing: 0.65px;
    color: ${({ theme }) => theme.TableLabelColor};
    /* border-bottom: 1px solid black; */
  }
`;

export const TableCellStats = styled.div<TableCellPropsType & { withoutBorder?: boolean; isAction?: boolean }>`
  ${({ align }) => align && `text-align: ${align}`};
  font-family: ${({ theme }) => theme.baseFont};
  font-weight: bold;
  color: ${({ theme }) => theme.colorMain};
  word-break: break-word;
  text-align: left;
  padding: 1rem;

  ${({ theme }) => theme.breakpoints.up('lg')} {
    &:first-child {
      padding-left: 1.5rem;
    }
    &:last-child {
      padding-right: 1.5rem;
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    white-space: initial;
    padding-top: 0;
    padding-left: 1rem;
    padding-right: 0.625rem;
    font-family: ${({ theme }) => theme.baseFont};
    ${({ withoutBorder, theme }) => !withoutBorder && `border-right: 1px solid ${theme.borderColor}`};
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 0;
    font-size: 0.8rem;
    padding-right: 0.5rem;

    &:last-child {
      padding-right: 0;
    }

    ${({ isAction }) => isAction && `margin-right: -10px`};
  }
`;

const TableCell = css<TableCellPropsType>`
  ${({ align }) => align && `text-align: ${align}`};
  font-family: ${({ theme }) => theme.baseFont};

  word-break: break-word;
  text-align: left;
  padding: 1rem;

  ${({ theme }) => theme.breakpoints.up('lg')} {
    &:first-child {
      padding-left: 1.5rem;
    }
    &:last-child {
      padding-right: 1.5rem;
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    white-space: initial;
    padding-top: 0;
    padding-left: 1rem;
    padding-right: 0.625rem;
    font-family: ${({ theme }) => theme.baseFont};

    width: 50%;
    &:nth-of-type(odd) {
      border-right: 1px solid ${({ theme }) => theme.borderColor};
    }
  }
`;

export const TableCellInfoData = styled.div`
  ${TableCell}

  ${({ theme }) => theme.breakpoints.down('md')} {
    white-space: initial;
    padding-top: 0;
    padding-left: 1rem;
    padding-right: 0.625rem;
    font-family: ${({ theme }) => theme.baseFont};
    width: unset;
    border-right: 1px solid ${({ theme }) => theme.borderColor};
    border: 1px solid ${({ theme }) => theme.borderColor};
    border-radius: 10px;
    padding: 10px;
    margin: 0 10px 10px 10px;
  }
`;

export const Match = styled.div`
  display: grid;
  grid-template-columns: 35px 1fr;
  grid-column-gap: 10px;
  border: 1px solid ${({ theme }) => theme.borderColor};

  border-radius: 10px;
  padding: 5px 8px;
  margin: 0 10px 10px 10px;
`;

export const MatchDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
`;

export const MatchDataContainerWithBorder = styled(MatchDataContainer)`
  border-left: 1px solid black;
  padding-left: 5px;
  font-size: 1rem;
`;

export const TableCellCustom = styled.td<TableCellPropsType>`
  ${TableCell}
`;

export const TableHeaderCustom = styled.th<TableCellPropsType>`
  ${TableCell}
  display: table-cell;

  ${({ width }) => width && `width: ${width}`};
  color: white;
  /* color: ${({ theme }) => theme.cardFontColor}; */

  &:first-child {
    border-top-left-radius: 10px;
  }
  &:last-child {
    border-top-right-radius: 10px;
  }
`;

export const TableCellAction = styled(TableCellCustom).attrs({
  align: 'right',
})`
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
    border: none;
    padding-bottom: 0;
    text-align: right;
    &:nth-of-type(odd) {
      border: none;
    }
  }
`;

export const TableRowCustom = styled.tr<TableRowPropsType>`
  color: ${({ theme }) => theme.colorSecondary};
  font-weight: bold;
  position: relative;

  ${({ statsStatus }) =>
    statsStatus &&
    statsStatus !== 'none' &&
    css`
      &:after {
        content: '';
        width: 3px;
        background-color: ${statsStatus === 'pass' ? '#C4F5E8' : '#F7E5D2'};
        height: 100%;
        position: absolute;
        left: 0;
      }
    `}

  ${({ highlightRow, theme }) =>
    highlightRow &&
    css`
      &:nth-of-type(${highlightRow}) {
        color: ${theme.colorMain};
        background: ${theme.TableHighlightBackground};
      }
    `}

  ${({ theme }) => theme.breakpoints.down('md')} {
    border-radius: 0.625rem;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0.625rem;
    padding-top: 1rem;
    padding-bottom: 1rem;

    border: 1px solid transparent;
    ${modeProperty('light', 'border-color', (theme) => theme.borderColor)};

    ${modeProperty('dark', 'background', (theme) => theme.TableHighlightBackground)};
    ${modeProperty('light', 'background', (theme) => theme.backgroundMain)};
  }

  ${({ isHover }) => isHover && hoverTableItemMixin}
`;

export const TableHeadCustom = styled.thead`
  background-color: ${({ theme }) => theme.colorMain};

  ${TableCellCustom} {
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.8px;
    color: ${({ theme }) => theme.colorLight};
    text-transform: uppercase;
    display: table-header-group;
  }
`;

export const TableBodyCustom = styled.tbody`
  display: table-row-group;
`;

export const TableCustom = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
`;

export const TableContainerCustom = styled.div`
  font-size: 1rem;
  letter-spacing: 0.23px;
  overflow-y: auto;
  padding: 0 1rem 1rem;
  background: ${({ theme }) => theme.TableBackground};
  ${({ theme }) => theme.breakpoints.down('md')} {
    background: transparent;
  }
`;

export const SimpleTableContainer = styled.div<SimpleContainerProps>`
  ${({ theme }) => theme.breakpoints.up('lg')} {
    border-radius: ${({ roundedTop, roundedBottom }) => (roundedTop && roundedBottom ? '0.5rem' : roundedTop ? '.5rem .5rem 0 0' : '0 0 .5rem .5rem')};

    ${({ theme, hasBorder }) => hasBorder && `border: 1px solid ${theme.borderColor}`};
    ${({ roundedBottom }) =>
      roundedBottom &&
      `
      .pagination-container {
        border-radius: 0 0 .5rem .5rem;
      }
    `}
    ${({ roundedTop }) =>
      roundedTop &&
      `
      ${TableContainerCustom} {
        border-radius: .5rem .5rem 0 0;
      }
    `}
  }
`;
